import { computed, toValue, watch } from "vue";

import { useListRole } from "#ce/components/SpList/composables/useListRole";
import { toBoolean } from "#ce/utils/props";

/** Reports the popup role of the panel's bound rows, including an empty loading list. */
export function usePanelPopupRole({ panel, items, readonly, tree, loading, isHeader, getItemProps }) {
  const { listRole } = useListRole({
    items,
    readonly,
    tree,
    isHeader,
    getItemProps,
  });

  const hasItems = computed(() => (toValue(items) ?? []).length > 0);

  const popupRole = computed(() => {
    if (toBoolean(toValue(readonly))) {
      return undefined;
    }

    if (hasItems.value) {
      return listRole.value;
    }

    if (toBoolean(toValue(loading))) {
      return "listbox";
    }

    return undefined;
  });

  function reportPopupRole() {
    toValue(panel)?.dispatchEvent(
      new CustomEvent("update-popup-role", {
        detail: [popupRole.value],
        bubbles: true,
      }),
    );
  }

  watch([panel, popupRole], reportPopupRole, {
    flush: "post",
    immediate: true,
  });

  return { popupRole };
}
